// Phone helpers shared by the web app (via @fn) and edge functions.

const DIAL_CODES: Record<string, string> = { KGS: '996', KZT: '7', RUB: '7', UZS: '998' };

/** Country calling code for a studio, inferred from its currency ('' when unknown). */
export function dialCode(currency: string): string {
  return DIAL_CODES[currency] ?? '';
}

/**
 * Digits in international form for wa.me. Clients often type local numbers:
 * "0502 977 773" (trunk 0) or "502977773" (no prefix) become 996502977773 for a KGS studio.
 */
export function intlDigits(phone: string, code = ''): string {
  const d = phone.replace(/\D/g, '');
  if (!code || d.startsWith(code)) return d;
  if (code === '7' && d.length === 11 && d.startsWith('8')) return `7${d.slice(1)}`;
  if (d.length === 10 && d.startsWith('0')) return code + d.slice(1);
  if (code === '996' && d.length === 9) return code + d;
  return d;
}

/** wa.me link; `text` pre-fills the message. `code` turns local numbers into international ones. */
export function whatsappHref(phone: string, text?: string, code = ''): string {
  const base = `https://wa.me/${intlDigits(phone, code)}`;
  return text ? `${base}?text=${encodeURIComponent(text)}` : base;
}
